import React, { useRef, useEffect, useState } from 'react';
import useOnScreen from 'hooks/useOnScreen';
import { ImageContainer } from './LazyImageStyles';

function LazyImage({ src, className, rootMargin = '0px', alt = 'Truckmarket' }) {
  const defaultSrc =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='270px' height='180px' style='background:rgba(0, 0,0, 0.08);'%3E%3C/svg%3E";
  const [currentSrc, setSrc] = useState(defaultSrc);
  const ref = useRef(null);
  const onScreen = useOnScreen(ref, rootMargin, 'lazy');

  useEffect(() => {
    if (onScreen) {
      setSrc(src);
    }
  }, [onScreen]);

  return (
    <ImageContainer className={className}>
      <img ref={ref} src={currentSrc} alt={alt} />
    </ImageContainer>
  );
}

export default LazyImage;
